<template>
  <picture>
    <source :srcset="photo.jpegSrcSet()" type="image/jpeg"/>
    <source :srcset="photo.webpSrcSet()" type="image/webp"/>
    <img :src="photo.defaultSrc()" type="image/jpeg" alt="Hochzeitsfoto"/>
  </picture>
</template>

<script>
import Photo from '@/gallery/photo';

export default {
  name: 'LightboxPhoto',

  props: {
    photo: {
      type: Photo,
      required: true,
    },
  },
};
</script>
